export enum ArticleRelativeBrand {
  TUR_SEGAFREDO = 'tur_segafredo',
  NORDSEE = 'nordsee',
  COFFEE_FELLOWS = 'coffee_fellows',
  DALLMAYR = 'dallmayr',
}
